import React from 'react';

export default function SlickArrow(props) {
    const { className, otherClassName, style, onClick, src } = props;
    return (
        <div className={className + " " + otherClassName} style={{ ...style, display: 'block', width: 'auto', height: 'auto' }}>
            <img src={src} alt={src.name}
                onClick={onClick}
            />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/SlickArrow.js